import {
  APPLICATION_STATUS_REQUEST,
  APPLICATION_STATUS_REQUEST_SUCCESS,
  APPLICATION_STATUS_REQUEST_FAILURE,
  APPLICATION_STATUS_CLEAN_REQUEST,
} from './actionTypes';

export const applicationStatusRequest = () => {
  return {
    type: APPLICATION_STATUS_REQUEST,
  };
};

export const applicationStatusRequestSuccess = (data) => {
  return {
    type: APPLICATION_STATUS_REQUEST_SUCCESS,
    data,
  };
};

export const applicationStatusRequestFailure = (error) => {
  return {
    type: APPLICATION_STATUS_REQUEST_FAILURE,
    error,
  };
};

export const applicationStatusCleanRequest = () => {
  return {
    type: APPLICATION_STATUS_CLEAN_REQUEST,
  };
};
